/**
 * Created by mzhao on 07/05/2022.
 * Description:
 * ContactListBulkEdit Component
 * ------ maintenance history ------
 */
import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { Subject, Subscription } from 'rxjs';
import { ContactListActionFeedback, ContactListActionType } from '../contact-list.model';
@Component({
    selector: 'tam-contact-list-bulk-edit',
    templateUrl: './contact-list-bulk-edit.component.html',
    styleUrls: ['./contact-list-bulk-edit.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactListBulkEditComponent implements OnInit, OnDestroy, ICellRendererAngularComp {
    //#region public properties
    checkboxValue = false;
    //#endregion

    //#region private properties

    /**
    * the subscription array that would be unsubscribed on destroying.
    */
    private _data: any;
    private _feedbackSubject$: Subject<ContactListActionFeedback>;
    private _destroySubscriptions: Array<Subscription> = [];

    //#endregion

    constructor(private _changeDetectorRef: ChangeDetectorRef) { }

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: any): void {
        this._data = params.data;
        this._feedbackSubject$ = params.feedbackSubject$();
        this.checkboxValue = this._data.isChecked;
        this._changeDetectorRef.detectChanges();
    }

    afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    }

    //#region public methods

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    onCheckBoxClick() {
        this._data['isChecked'] = this.checkboxValue;
        this._feedbackSubject$.next({
            type: ContactListActionType.CHECK_ITEM,
            payload: {
                data: this._data
            }
        });
    }

    //#endregion

    //#region private methods

    //#endregion
}
